import { atom } from "jotai";
import {
  ConversationSummary,
  ConversationFullDetails,
  ChatResponse,
} from "../../features/copilot/copilot.api";

export interface Interaction {
  userMessage: string;
  response: ChatResponse;
  timestamp: Date;
}

export interface LoadedConversation {
  id: string;
  accountId: number;
  messages: Array<{
    id: string;
    role: string;
    content: string;
    inputTokens?: number;
    outputTokens?: number;
    cost?: number;
    timestamp: string;
  }>;
  interactions: Interaction[];
  conversationSummary?: ConversationSummary | ConversationFullDetails;
}

// Writable atom - no explicit type annotation needed
export const loadedConversationAtom = atom(null as LoadedConversation | null);

/**
 * Global atom to control the help panel state from anywhere in the app.
 * Used by action:copilot to open the AI help panel.
 */
export type HelpPanelState = "collapsed" | "panel" | "modal";
export const helpPanelStateAtom = atom<HelpPanelState>("collapsed");

/**
 * Prefill message for the copilot chat input.
 * When set, the MessageInput will display this text and then clear the atom.
 * Used by ExhaustionWall "Ask AI" action.
 */
export const copilotPrefillAtom = atom(null as string | null);

/**
 * When true, the *next* Copilot user message should NOT be persisted to
 * sessionStorage for Concierge handoff. Set by ExhaustionWall before injecting
 * a plan-help prefill — we don't want Concierge to auto-send a plan question
 * intended for Copilot Help (wastes Concierge tokens). Consumed + reset by
 * useCopilotChat.sendMessage on the next send.
 */
export const suppressConciergeHandoffAtom = atom(false);
